import { useTranslation } from 'next-i18next';
import { LocalImage } from '../../Image';
import { Modal } from 'antd';

import closeIcon from '../../../assets/Edit/close.png';

import styles from './index.module.scss';
import { useState } from 'react';
import { loadingIcon } from '../../../assets';

interface ISimpleModalProps {
  show: boolean;
  title: string;
  desc?: string;
  confirmText: string;
  onClose: () => void;
  onConfirm: () => void;
}

export function SimpleModal({
  show,
  title,
  desc,
  confirmText,
  onClose,
  onConfirm,
}: ISimpleModalProps) {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  return (
    <Modal
      centered
      open={show}
      onCancel={onClose}
      closeIcon={null}
      footer={
        <div className={styles.simpleModalBtns}>
          <button className={styles.cancelBtn} onClick={onClose}>
            {t('cancel')}
          </button>
          <button
            className={styles.confirmBtn}
            onClick={async () => {
              if (loading) return;
              try {
                setLoading(true);
                await onConfirm();
                onClose();
              } finally {
                setLoading(false);
              }
            }}
          >
            {loading && <LocalImage className="animate-spin mr-[8px]" src={loadingIcon} />}
            {confirmText}
          </button>
        </div>
      }
    >
      <div className={styles.header}>
        <h2 className={styles.title}>{title}</h2>
        <LocalImage src={closeIcon} width={24} height={24} onClick={onClose} />
      </div>
      {desc && <div className={styles.desc}>{desc}</div>}
    </Modal>
  );
}
